import { DialogActions } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import KsbActionButton from "./KsbActionButton";
import { Check, Close, Delete, Warning } from "@mui/icons-material";

function KsbDialogActions({
  onCancel,
  onConfirm,

  cancelLabel = "Abbrechen",
  confirmLabel = "Speichern",

  confirmDisabled = false,
  confirmColor = "primary",

  secondaryAction,
  secondaryLabel,
  secondaryColor = "warning",

  dangerAction,
  dangerLabel,
  dangerConfirm = null,
  confirmConfirm = null,
}) {
  const theme = useTheme();
  const confirmStyles = {
    primary: {
      bgcolor: theme.palette.primary.main,
      "&:hover": {
        bgcolor: theme.palette.primary.dark,
        transform: "translateY(-1px)",
      },
    },
    error: {
      bgcolor: "error.main",
      color: "error.contrastText",
      "&:hover": {
        bgcolor: "error.dark",
        transform: "translateY(-1px)",
      },
    },
    success: {
      bgcolor: "success.main",
      "&:hover": {
        bgcolor: "success.dark",
        transform: "translateY(-1px)",
      },
    },
    warning: {
      bgcolor: "warning.main",
      color: "warning.contrastText",
      "&:hover": {
        bgcolor: "warning.dark",
        transform: "translateY(-1px)",
      },
    },
  };
  return (
    <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
      {/* LEFT */}
      <KsbActionButton
        onClick={onCancel}
        label={cancelLabel}
        variant="text"
        icon={<Close />}
        sx={confirmStyles.error}
      />

      {/* RIGHT */}
      <div style={{ display: "flex", gap: 8 }}>
        {/* ✅ ADMIN DELETE */}
        {dangerAction && dangerLabel && (
          <KsbActionButton
            onClick={dangerAction}
            label={dangerLabel}
            variant="outlined"
            icon={<Delete />}
            confirm={dangerConfirm}
            sx={{
              color: "error.main",
              borderColor: "error.main",

              "&:hover": {
                bgcolor: "error.light",
              },
            }}
          />
        )}

        {/* ✅ SECONDARY (Freigeben) */}
        {secondaryAction && secondaryLabel && (
          <KsbActionButton
            onClick={secondaryAction}
            label={secondaryLabel}
            variant="contained"
            icon={<Warning />}
            sx={confirmStyles.warning}
          />
        )}

        {/* ✅ CONFIRM */}
        <KsbActionButton
          onClick={onConfirm}
          label={confirmLabel}
          variant="contained"
          disabled={confirmDisabled}
          icon={<Check />}
          sx={confirmStyles[confirmColor]}
          confirm={confirmConfirm}
        />
      </div>
    </DialogActions>
  );
}
export default KsbDialogActions;
